var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetflix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 30,
    viewBox: "0 0 110 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1253 27.8206C13.4706 28.1112 11.7868 28.1983 10.0449 28.4303L4.73204 12.8696V29.0982C3.07731 29.2723 1.56771 29.5046 0 29.7368V0.00866699H4.41289L10.4513 16.8762V0.00866699H15.1253V27.8206ZM24.2703 10.8954C26.0703 10.8954 28.8283 10.8083 30.483 10.8083V15.4532C28.4217 15.4532 26.0122 15.4532 24.2703 15.5404V22.45C26.9993 22.2758 29.7283 22.0434 32.4861 21.9562V26.4268L19.6251 27.4431V0.00866699H32.4861V4.6537H24.2703V10.8954ZM49.7597 4.6538H44.9406V26.0209C43.3729 26.0209 41.8052 26.0209 40.2958 26.0788V4.6538H35.4766V0.00866699H49.76L49.7597 4.6538ZM57.3079 10.5762H63.6658V15.2211H57.3079V25.7596H52.7496V0.00866699H65.727V4.6537H57.3079V10.5762ZM73.2751 21.6951C75.9171 21.753 78.5878 21.9566 81.1717 22.1015V26.6885C77.0203 26.427 72.8688 26.1661 68.6302 26.0788V0.00866699H73.2751V21.6951ZM85.0909 27.0079C86.5715 27.0951 88.1392 27.1822 89.6488 27.3561V0.00866699H85.0909V27.0079ZM110 0.00866699L104.107 14.147L110 29.7368C108.258 29.5046 106.516 29.1852 104.774 28.8948L101.436 20.3017L98.0393 28.1983C96.3552 27.9077 94.7294 27.8206 93.0459 27.5884L99.0263 13.9727L93.6263 0.00866699H98.6195L101.668 7.81813L104.919 0.00866699H110Z",
    fill: "#D81F26"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 29.744,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetflix);
export default __webpack_public_path__ + "static/media/netflix.e8acba0700d6872265ea0fc631f14d93.svg";
export { ForwardRef as ReactComponent };